import {Column} from 'react-table'
import {PartnerInfoCell} from './PartnerInfoCell'
import {PartnerActionsCell} from './PartnerActionsCell'
import {PartnerCustomHeader} from './PartnerCustomHeader'
import { PartnerPersonInChargeCell } from './PartnerPersonInChargeCell'
import { PartnerOrganization } from '../../../core/_models'

const partnerOrganizerColumns: ReadonlyArray<Column<PartnerOrganization>> = [
  {
    Header: (props) => <PartnerCustomHeader tableProps={props} title='No' className='min-w-50px' />,
    id: 'no',
    Cell: (props) => <label>{props.row.index + 1}</label>
  },
  {
    Header: (props) => <PartnerCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <PartnerInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <PartnerCustomHeader tableProps={props} title='Organization' className='min-w-125px' />,
    accessor: 'organization_name',
  },
  {
    Header: (props) => <PartnerCustomHeader tableProps={props} title='Person in Charge' className='min-w-125px' />,
    id: 'person-in-charger',
    Cell: ({...props}) => <PartnerPersonInChargeCell partnerOrganization={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PartnerCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <PartnerActionsCell id={props.data[props.row.index].guid!} />,
  },
]

export {partnerOrganizerColumns}
